import { Box, CircularProgress, useTheme } from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";
import { getLocalizedMessage, SupportedLanguage } from "@pimo/pimo-l10n";

export type MagicLinkPageProps = {
  language: SupportedLanguage;
};

export const MagicLinkPage: PimoReactComponent<MagicLinkPageProps> = ({
  language,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress
        aria-label={getLocalizedMessage(language, "magicLink.signingIn")}
      />
    </Box>
  );
};
